// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getAuth} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD-qTqxpJhKkDvEp5LSHf2VOFVNntWRM0s",
  authDomain: "niruprint-solutions.firebaseapp.com",
  projectId: "niruprint-solutions",
  storageBucket: "niruprint-solutions.firebasestorage.app",
  messagingSenderId: "757562000472",
  appId: "1:757562000472:web:1e880391cff1b6221f762d",
  measurementId: "G-06KBXZFM8Q"
};



// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export {app, auth, analytics, db};